import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIsAuthenticated, signedIn, signedOut } from '../store/slices/auth';
import { AnalyticsEvents, trackEvent } from '../utils/analytics';
import { flushSessionSource } from '../utils/attribution';
import { clearAccessToken, setAccessToken } from '../utils/token-store';

export const useAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const userSignIn = useCallback(
    ({ token, redirectUrl }) => {
      setAccessToken(token);
      // First point in a new visitor's journey where the source parked at
      // landing has an account to attach to.
      flushSessionSource();
      dispatch(signedIn());
      navigate(redirectUrl);
    },
    [dispatch, navigate],
  );

  const userSignOut = useCallback(() => {
    trackEvent(AnalyticsEvents.LOGOUT);

    fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    }).catch(() => {});

    clearAccessToken();
    dispatch(signedOut());

    window.location.href = '/';
  }, [dispatch]);

  return { isAuthenticated, userSignIn, userSignOut };
};
